<template>
  <svg
    :viewBox="icon.viewBox"
    class="m-icon"
    @click="$emit('click', $event)"
  >
    <use
      ref="useElement"
      :href="iconUrl"
    />
  </svg>
</template>

<script>
  import generateLink from 'utils/common/generateLink';

  export default {
    name: 'MIcon',
    props: {
      icon: {
        type: Object,
        required: true
      }
    },
    computed: {

      iconUrl () {
        // provide package version as query param to prevent loading from cache

        // eslint-disable-next-line no-undef
        const libVersion = LIB_VERSION;
        const [svgUrl, spriteAnchor] = this.icon.url.split('#');

        return generateLink(`${svgUrl}?v=${libVersion}#${spriteAnchor}`);
      }
    }
  };
</script>

<style>
  /* stylelint-disable value-keyword-case */
  .m-icon {
    fill: currentColor;
  }
  /* stylelint-enable value-keyword-case */
</style>
